/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from './login.component.scss.ngstyle';
import * as import1 from '@angular/core';
import * as import2 from '../../../../../app/shared/login/login/login.component';
import * as import3 from '@angular/forms';
import * as import4 from '@angular/common';
import * as import5 from '../../../../../app/shared/login/common/auth.service';
const styles_LoginComponent:any[] = [import0.styles];
export const RenderType_LoginComponent:import1.RendererType2 = import1.ɵcrt({
  encapsulation: 2,
  styles: styles_LoginComponent,
  data: {}
}
);
function View_LoginComponent_1(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
    (l()(),import1.ɵeld(0,(null as any),(null as any),4,'div',[
      [
        'class',
        'alert alert-danger'
      ]
      ,
      [
        'role',
        'alert'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n            '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'strong',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['Oh vaya!'])),
    (l()(),import1.ɵted((null as any),[' Wrong email or password!\n          ']))
  ]
  ,(null as any),(null as any));
}
function View_LoginComponent_2(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
      (l()(),import1.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'form-control-feedback'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['Please enter your username']))
  ]
  ,(null as any),(null as any));
}
function View_LoginComponent_3(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
      (l()(),import1.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'form-control-feedback'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['Please enter your password']))
  ]
  ,(null as any),(null as any));
}
export function View_LoginComponent_0(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
    (l()(),import1.ɵeld(0,(null as any),(null as any),83,'div',[
      [
        'class',
        'modal fade'
      ]
      ,
      [
        'id',
        'loginpopup'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n  '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),80,'div',[
      [
        'class',
        'modal-dialog'
      ]
      ,
      [
        'role',
        'document'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n    '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),77,'div',[[
        'class',
        'modal-content'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n      '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),74,'form',[[
        'novalidate',
        ''
      ]
    ],[
      [
        2,
        'ng-untouched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-touched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pristine',
        (null as any)
      ]
      ,
      [
        2,
        'ng-dirty',
        (null as any)
      ]
      ,
      [
        2,
        'ng-valid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-invalid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pending',
        (null as any)
      ]

    ]
    ,[
      [
        (null as any),
        'ngSubmit'
      ]
      ,
      [
        (null as any),
        'submit'
      ]
      ,
      [
        (null as any),
        'reset'
      ]

    ]
    ,(v,en,$event) => {
      var ad:boolean = true;
      var co:import2.LoginComponent = v.component;
      if (('submit' === en)) {
        const pd_0:any = ((<any>import1.ɵnov(v,8).onSubmit($event)) !== false);
        ad = (pd_0 && ad);
      }
      if (('reset' === en)) {
        const pd_1:any = ((<any>import1.ɵnov(v,8).onReset()) !== false);
        ad = (pd_1 && ad);
      }
      if (('ngSubmit' === en)) {
        const pd_2:any = ((<any>co.doLogin($event)) !== false);
        ad = (pd_2 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import1.ɵdid(16384,(null as any),0,import3.ɵbf,([] as any[]),(null as any),(null as any)),
    import1.ɵdid(540672,(null as any),0,import3.FormGroupDirective,[
      [
        8,
        (null as any)
      ]
      ,
      [
        8,
        (null as any)
      ]

    ]
      ,{form: [
        0,
        'form'
      ]
    },{ngSubmit: 'ngSubmit'}),
    import1.ɵprd(2048,(null as any),import3.ControlContainer,(null as any),[import3.FormGroupDirective]),
    import1.ɵdid(16384,(null as any),0,import3.NgControlStatusGroup,[import3.ControlContainer],(null as any),(null as any)),
    (l()(),import1.ɵted((null as any),['\n        '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),10,'div',[[
        'class',
        'modal-header'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n          '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),1,'h5',[[
        'class',
        'modal-title'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['Login'])),
    (l()(),import1.ɵted((null as any),['\n          '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),4,'button',[
      [
        'aria-label',
        'Close'
      ]
      ,
      [
        'class',
        'close'
      ]
      ,
      [
        'data-dismiss',
        'modal'
      ]
      ,
      [
        'type',
        'button'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n            '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),1,'span',[[
        'aria-hidden',
        'true'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['×'])),
    (l()(),import1.ɵted((null as any),['\n          '])),
    (l()(),import1.ɵted((null as any),['\n        '])),
    (l()(),import1.ɵted((null as any),['\n        '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),46,'div',[[
        'class',
        'modal-body'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n          '])),
    (l()(),import1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_LoginComponent_1)),
    import1.ɵdid(16384,(null as any),0,import4.NgIf,[
      import1.ViewContainerRef,
      import1.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),['\n            '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),19,'div',[[
        'class',
        'form-group'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    import1.ɵdid(278528,(null as any),0,import4.NgClass,[
      import1.IterableDiffers,
      import1.KeyValueDiffers,
      import1.ElementRef,
      import1.Renderer
    ]
    ,{
      klass: [
        0,
        'klass'
      ]
      ,
      ngClass: [
        1,
        'ngClass'
      ]

    }
    ,(null as any)),
    import1.ɵpod(['has-danger']),
    (l()(),import1.ɵted((null as any),['\n              '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),11,'div',[[
        'class',
        'input-group mb-2 mr-sm-2 mb-sm-0'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n                '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'div',[
      [
        'class',
        'input-group-addon'
      ]
      ,
      [
        'style',
        'width: 40px;'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵeld(0,(null as any),(null as any),0,'i',[
      [
        'aria-hidden',
        'true'
      ]
      ,
      [
        'class',
        'fa fa-envelope-o'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n                '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),5,'input',[
      [
        'class',
        'form-control'
      ]
      ,
      [
        'formControlName',
        'username'
      ]
      ,
      [
        'id',
        'username'
      ]
      ,
      [
        'placeholder',
        'Username'
      ]
      ,
      [
        'type',
        'text'
      ]

    ]
    ,[
      [
        2,
        'ng-untouched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-touched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pristine',
        (null as any)
      ]
      ,
      [
        2,
        'ng-dirty',
        (null as any)
      ]
      ,
      [
        2,
        'ng-valid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-invalid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pending',
        (null as any)
      ]

    ]
    ,[
      [
        (null as any),
        'input'
      ]
      ,
      [
        (null as any),
        'blur'
      ]
      ,
      [
        (null as any),
        'compositionstart'
      ]
      ,
      [
        (null as any),
        'compositionend'
      ]

    ]
    ,(v,en,$event) => {
      var ad:boolean = true;
      if (('input' === en)) {
        const pd_0:any = ((<any>import1.ɵnov(v,39)._handleInput($event.target.value)) !== false);
        ad = (pd_0 && ad);
      }
      if (('blur' === en)) {
        const pd_1:any = ((<any>import1.ɵnov(v,39).onTouched()) !== false);
        ad = (pd_1 && ad);
      }
      if (('compositionstart' === en)) {
        const pd_2:any = ((<any>import1.ɵnov(v,39)._compositionStart()) !== false);
        ad = (pd_2 && ad);
      }
      if (('compositionend' === en)) {
        const pd_3:any = ((<any>import1.ɵnov(v,39)._compositionEnd($event.target.value)) !== false);
        ad = (pd_3 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import1.ɵdid(16384,(null as any),0,import3.DefaultValueAccessor,[
      import1.Renderer,
      import1.ElementRef,
      [
        2,
        import3.COMPOSITION_BUFFER_MODE
      ]

    ]
    ,(null as any),(null as any)),
    import1.ɵprd(1024,(null as any),import3.NG_VALUE_ACCESSOR,(p0_0:any) => {
      return [p0_0];
    },[import3.DefaultValueAccessor]),
    import1.ɵdid(671744,(null as any),0,import3.FormControlName,[
      [
        3,
        import3.ControlContainer
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        2,
        import3.NG_VALUE_ACCESSOR
      ]

    ]
      ,{name: [
        0,
        'name'
      ]
    },(null as any)),
    import1.ɵprd(2048,(null as any),import3.NgControl,(null as any),[import3.FormControlName]),
    import1.ɵdid(16384,(null as any),0,import3.NgControlStatus,[import3.NgControl],(null as any),(null as any)),
    (l()(),import1.ɵted((null as any),['\n              '])),
    (l()(),import1.ɵted((null as any),['\n              '])),
    (l()(),import1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_LoginComponent_2)),
    import1.ɵdid(16384,(null as any),0,import4.NgIf,[
      import1.ViewContainerRef,
      import1.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),['\n            '])),
    (l()(),import1.ɵted((null as any),['\n            '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),19,'div',[[
        'class',
        'form-group'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    import1.ɵdid(278528,(null as any),0,import4.NgClass,[
      import1.IterableDiffers,
      import1.KeyValueDiffers,
      import1.ElementRef,
      import1.Renderer
    ]
    ,{
      klass: [
        0,
        'klass'
      ]
      ,
      ngClass: [
        1,
        'ngClass'
      ]

    }
    ,(null as any)),
    import1.ɵpod(['has-danger']),
    (l()(),import1.ɵted((null as any),['\n              '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),11,'div',[[
        'class',
        'input-group mb-2 mr-sm-2 mb-sm-0'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n                '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'div',[
      [
        'class',
        'input-group-addon'
      ]
      ,
      [
        'style',
        'width: 40px;'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵeld(0,(null as any),(null as any),0,'i',[
      [
        'aria-hidden',
        'true'
      ]
      ,
      [
        'class',
        'fa fa-lock'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n                '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),5,'input',[
      [
        'class',
        'form-control'
      ]
      ,
      [
        'formControlName',
        'password'
      ]
      ,
      [
        'id',
        'password'
      ]
      ,
      [
        'placeholder',
        'Password'
      ]
      ,
      [
        'type',
        'password'
      ]

    ]
    ,[
      [
        2,
        'ng-untouched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-touched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pristine',
        (null as any)
      ]
      ,
      [
        2,
        'ng-dirty',
        (null as any)
      ]
      ,
      [
        2,
        'ng-valid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-invalid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pending',
        (null as any)
      ]

    ]
    ,[
      [
        (null as any),
        'input'
      ]
      ,
      [
        (null as any),
        'blur'
      ]
      ,
      [
        (null as any),
        'compositionstart'
      ]
      ,
      [
        (null as any),
        'compositionend'
      ]

    ]
    ,(v,en,$event) => {
      var ad:boolean = true;
      if (('input' === en)) {
        const pd_0:any = ((<any>import1.ɵnov(v,60)._handleInput($event.target.value)) !== false);
        ad = (pd_0 && ad);
      }
      if (('blur' === en)) {
        const pd_1:any = ((<any>import1.ɵnov(v,60).onTouched()) !== false);
        ad = (pd_1 && ad);
      }
      if (('compositionstart' === en)) {
        const pd_2:any = ((<any>import1.ɵnov(v,60)._compositionStart()) !== false);
        ad = (pd_2 && ad);
      }
      if (('compositionend' === en)) {
        const pd_3:any = ((<any>import1.ɵnov(v,60)._compositionEnd($event.target.value)) !== false);
        ad = (pd_3 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import1.ɵdid(16384,(null as any),0,import3.DefaultValueAccessor,[
      import1.Renderer,
      import1.ElementRef,
      [
        2,
        import3.COMPOSITION_BUFFER_MODE
      ]

    ]
    ,(null as any),(null as any)),
    import1.ɵprd(1024,(null as any),import3.NG_VALUE_ACCESSOR,(p0_0:any) => {
      return [p0_0];
    },[import3.DefaultValueAccessor]),
    import1.ɵdid(671744,(null as any),0,import3.FormControlName,[
      [
        3,
        import3.ControlContainer
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        2,
        import3.NG_VALUE_ACCESSOR
      ]

    ]
      ,{name: [
        0,
        'name'
      ]
    },(null as any)),
    import1.ɵprd(2048,(null as any),import3.NgControl,(null as any),[import3.FormControlName]),
    import1.ɵdid(16384,(null as any),0,import3.NgControlStatus,[import3.NgControl],(null as any),(null as any)),
    (l()(),import1.ɵted((null as any),['\n              '])),
    (l()(),import1.ɵted((null as any),['\n              '])),
    (l()(),import1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_LoginComponent_3)),
    import1.ɵdid(16384,(null as any),0,import4.NgIf,[
      import1.ViewContainerRef,
      import1.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),['\n            '])),
    (l()(),import1.ɵted((null as any),['\n        '])),
    (l()(),import1.ɵted((null as any),['\n        '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),7,'div',[[
        'class',
        'modal-footer'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n          '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'button',[
      [
        'class',
        'btn btn-secondary'
      ]
      ,
      [
        'data-dismiss',
        'modal'
      ]
      ,
      [
        'type',
        'button'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['Close'])),
    (l()(),import1.ɵted((null as any),['\n          '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'button',[
      [
        'class',
        'btn btn-primary'
      ]
      ,
      [
        'type',
        'submit'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['Login'])),
    (l()(),import1.ɵted((null as any),['\n        '])),
    (l()(),import1.ɵted((null as any),['\n      '])),
    (l()(),import1.ɵted((null as any),['\n    '])),
    (l()(),import1.ɵted((null as any),['\n  '])),
    (l()(),import1.ɵted((null as any),['\n'])),
    (l()(),import1.ɵted((null as any),['\n\n'])),
    (l()(),import1.ɵted((null as any),['\n'])),
      (l()(),import1.ɵeld(0,[[
        'loginBtn',
        1
      ]
      ],(null as any),1,'button',[[
        'id',
        'login-button'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),[' '])),
    (l()(),import1.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    var co:import2.LoginComponent = v.component;
    const currVal_7:any = co.loginForm;
    ck(v,8,0,currVal_7);
    const currVal_8:any = co.showError;
    ck(v,27,0,currVal_8);
    const currVal_9:any = 'form-group';
    const currVal_10:any = ck(v,31,0,(!co.loginForm.controls['username'].valid && co.loginForm.controls['username'].touched));
    ck(v,30,0,currVal_9,currVal_10);
    const currVal_18:any = 'username';
    ck(v,41,0,currVal_18);
    const currVal_19:any = (co.loginForm.controls['username'].hasError('required') && co.loginForm.controls['username'].touched);
    ck(v,47,0,currVal_19);
    const currVal_20:any = 'form-group';
    const currVal_21:any = ck(v,52,0,(!co.loginForm.controls['password'].valid && co.loginForm.controls['password'].touched));
    ck(v,51,0,currVal_20,currVal_21);
    const currVal_29:any = 'password';
    ck(v,62,0,currVal_29);
    const currVal_30:any = (co.loginForm.controls['password'].hasError('required') && co.loginForm.controls['password'].touched);
    ck(v,68,0,currVal_30);
  },(ck,v) => {
    const currVal_0:any = import1.ɵnov(v,10).ngClassUntouched;
    const currVal_1:any = import1.ɵnov(v,10).ngClassTouched;
    const currVal_2:any = import1.ɵnov(v,10).ngClassPristine;
    const currVal_3:any = import1.ɵnov(v,10).ngClassDirty;
    const currVal_4:any = import1.ɵnov(v,10).ngClassValid;
    const currVal_5:any = import1.ɵnov(v,10).ngClassInvalid;
    const currVal_6:any = import1.ɵnov(v,10).ngClassPending;
    ck(v,6,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6);
    const currVal_11:any = import1.ɵnov(v,43).ngClassUntouched;
    const currVal_12:any = import1.ɵnov(v,43).ngClassTouched;
    const currVal_13:any = import1.ɵnov(v,43).ngClassPristine;
    const currVal_14:any = import1.ɵnov(v,43).ngClassDirty;
    const currVal_15:any = import1.ɵnov(v,43).ngClassValid;
    const currVal_16:any = import1.ɵnov(v,43).ngClassInvalid;
    const currVal_17:any = import1.ɵnov(v,43).ngClassPending;
    ck(v,38,0,currVal_11,currVal_12,currVal_13,currVal_14,currVal_15,currVal_16,currVal_17);
    const currVal_22:any = import1.ɵnov(v,64).ngClassUntouched;
    const currVal_23:any = import1.ɵnov(v,64).ngClassTouched;
    const currVal_24:any = import1.ɵnov(v,64).ngClassPristine;
    const currVal_25:any = import1.ɵnov(v,64).ngClassDirty;
    const currVal_26:any = import1.ɵnov(v,64).ngClassValid;
    const currVal_27:any = import1.ɵnov(v,64).ngClassInvalid;
    const currVal_28:any = import1.ɵnov(v,64).ngClassPending;
    ck(v,59,0,currVal_22,currVal_23,currVal_24,currVal_25,currVal_26,currVal_27,currVal_28);
  });
}
function View_LoginComponent_Host_0(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'login',([] as any[]),(null as any),(null as any),(null as any),View_LoginComponent_0,RenderType_LoginComponent)),
    import1.ɵdid(4243456,(null as any),0,import2.LoginComponent,[
      import5.AuthService,
      'isBrowser',
      import3.FormBuilder,
      import1.ElementRef
    ]
    ,(null as any),(null as any))
  ]
  ,(null as any),(null as any));
}
export const LoginComponentNgFactory:import1.ComponentFactory<import2.LoginComponent> = import1.ɵccf('login',import2.LoginComponent,View_LoginComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./src/ngfactory/app/shared/login/login/login.component.ngfactory.ts